import(/* webpackMode: "eager" */ "D:\\VQBITS\\BeyonliServices Project\\BeyonliServices\\frontend\\src\\app\\page.tsx");
